import React from 'react';
import renderTextField from '@app/components/Layout/Shares/FormHelpers/TextField';
import renderSwitchField from '@app/components/Layout/Shares/FormHelpers/SwitchField';
import validate from './validate';
import { ScModalFinalForm, ScField } from '@app/components/Base/ScFinalForm';

const AccountRoleModal = ({ isShow, onClose, onSubmit, initialValues }) => (
    <ScModalFinalForm
        title="Vai trò"
        open={isShow}
        onClose={onClose}
        onSubmit={onSubmit}
        validate={validate}
        initialValues={initialValues}
    >
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <ScField
                        name="sr_sortorder"
                        component={renderTextField}
                        label="Số thứ tự"
                        className="form-control"
                        type="number"
                        min="1"
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <ScField
                        name="sr_status"
                        component={renderSwitchField}
                        label="Đang sử dụng"
                    />
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <ScField
                        name="sr_name"
                        component={renderTextField}
                        label="Tên vai trò"
                        className="form-control"
                    />
                </div>
            </div>
        </div>
    </ScModalFinalForm>
);

export default AccountRoleModal;
